/**
 * Constantes compartidas para la aplicación de compras
 */

export const SHIPPING_METHODS = [
  { value: 'Nostres mitjans', label: 'Nostres mitjans' },
  { value: 'Transport proveidor', label: 'Transport proveidor' },
  { value: 'Missatgeria', label: 'Missatgeria' },
  { value: 'Recollida', label: 'Recollida' },
] as const;

export const SHIPPING_METHOD_VALUES = SHIPPING_METHODS.map(m => m.value);
